import Icon from '../components/Icon.vue'

Icon.register({"id-badge":{"width":384,"height":512,"paths":[{"d":"M336 0H48C21.5 0 0 21.5 0 48V464C0 490.5 21.5 512 48 512H336C362.5 512 384 490.5 384 464V48C384 21.5 362.5 0 336 0zM128 44C128 37.4 133.4 32 140 32H244C250.6 32 256 37.4 256 44V52C256 58.6 250.6 64 244 64H140C133.4 64 128 58.6 128 52V44zM192 160C236.2 160 272 195.8 272 240S236.2 320 192 320 112 284.2 112 240 147.8 160 192 160zM320 392C320 405.3 309.3 416 296 416H88C74.7 416 64 405.3 64 392V373.5C64 351.5 79 332.3 100.4 326.9L136 318C165.1 338.9 210.5 344.9 248 318L283.6 326.9C305 332.3 320 351.5 320 373.5V392z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/id-badge.js
// module id = null
// module chunks = 